<div class="mt-5">
   <div class="flex justify-between items-center mb-3 -mt-5 w-full">
<!-- LEFT SIDE: TITLE -->
  <div>
    <h3 class="m-0 text-xl font-semibold">Add-ons</h3>
    <p class="text-gray-500 text-sm mt-1">Manage marketplace add-ons</p>
  </div>

  <!-- RIGHT SIDE: SEARCH + BUTTON -->
  <div class="flex items-center gap-3">

    <!-- SEARCH BAR -->
    <div class="flex items-center gap-2 border rounded-lg px-3 py-2 bg-white">
      <i class="pi pi-search text-gray-500"></i>
      <input 
        pInputText 
        [(ngModel)]="searchText" 
        placeholder="Search packages..." 
        class="outline-none border-none p-0"
      />
    </div>

    <!-- ADD PACKAGE BUTTON -->
    <p-button 
      label="New Add-On" 
      icon="pi pi-plus" 
      (onClick)="openCreateAddon()">
    </p-button>

  </div>
</div>
  <p-table
    [value]="filterAddons()"
    [loading]="loading"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [rowsPerPageOptions]="[10, 25, 50]"
    styleClass="p-datatable-striped"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          Name <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th>
          Features
        </th>
        <th>Description</th>
        <th>Status</th>
        <th style="width: 120px;">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-addon>
      <tr>
        <td>
          <div class="font-semibold">{{ addon.name }}</div>
        </td>

        <td>
          <span class="text-sm text-gray-600">{{ getFeaturesSummary(addon.feature) }}</span>
        </td>

        <td>
          <span class="text-sm">{{ addon.description || '-' }}</span>
        </td>

        <td>
          <p-tag
            [value]="getStatusLabel(addon.is_active)"
            [severity]="getStatusSeverity(addon.is_active)">
          </p-tag>
        </td>

        <td>
          <div class="flex gap-2">
            <p-button
              label="Edit"
              icon="pi pi-pencil"
              severity="secondary"
              (onClick)="onEdit(addon)"
              pTooltip="Edit"
            ></p-button>

            <p-button
              label="Delete"
              icon="pi pi-trash"
              severity="danger"
              (onClick)="onDelete(addon)"
              pTooltip="Delete"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center py-4">
          <i class="pi pi-inbox text-4xl text-gray-400 mb-3"></i>
          <p class="text-gray-500">No add-ons found</p>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
